export const GET_SELF_BILLING_INVOICES = gql`
    query selfBillingInvoices {
        selfBillingInvoices {
            id
            createdAt
            updatedAt
            partner {
                id
                name
                firstName
                lastName
            }
            sageInvoiceId
            sageInvoiceNumber
            status
            lineItems {
                description
                ledgerAccount
                lineTotal
                netAmount
                productOrService
                quantity
                totalVat
            }
            commissionStatements {
                statementDate
            }
        }
    }
`;

export const GET_SELF_BILLING_INVOICE = gql`
    query selfBillingInvoice($id: Int!) {
        selfBillingInvoice(id: $id) {
            id
            invoiceDate
            createdAt
            partner {
                name
                billingContactInformation
                firstName
                lastName
                business {
                    legalName
                }
            }
            # invoiceDate
            invoiceItems {
                description
                ledgerAccount
                commissionStatementId {
                    commissionStatementId
                    id
                }
                lineTotal
                netAmount
                productOrService
                quantity
                totalVat
            }
            status
            totals {
                invoiceAmount
                netAmount
                vatAmount
            }
        }
    }
`;

export const GET_SELF_BILLING_INVOICE_PDF = gql`
    query selfBillingInvoicePDF($id: Int!) {
        selfBillingInvoicePDF(id: $id) {
            pdfBase64
        }
    }
`;
